/* src/app/views/template/components/shared/template-location-selection-group/template-location-selection-group.component.scss */
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f6px {
  font-size: 0.375rem;
}
.f8px {
  font-size: 0.5rem;
}
.f10px {
  font-size: 0.625rem;
}
.f11px {
  font-size: 0.6875rem;
}
.f12px {
  font-size: 0.75rem;
}
.f13px {
  font-size: 0.8125rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
:host ::ng-deep .mat-expansion-panel-header {
  padding: 0 0.3rem 0 0 !important;
  border-radius: 0;
  border-bottom: 1px solid #f2f2f2;
  transition: none !important;
}
:host ::ng-deep .mat-expansion-panel-header:hover {
  background-color: #ffffff !important;
}
:host ::ng-deep .mat-expansion-panel-header:not(:focus-visible) {
  background: none !important;
}
:host ::ng-deep .mat-content {
  height: 100%;
}
:host ::ng-deep .mat-expansion-panel-body {
  padding: 0;
}
:host ::ng-deep .mat-expansion-indicator::after {
  height: 0.8rem !important;
  width: 0.8rem !important;
  color: black !important;
  vertical-align: initial !important;
}
.province-name {
  font-size: 0.75rem;
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #222222;
}
.checked-count {
  margin-left: 0.25rem;
  font-size: 0.6rem;
}
.n-selected {
  width: 1.5rem;
}
/*# sourceMappingURL=template-location-selection-group.component.css.map */
